<template>
  <div style="margin-bottom:0.5em;">
    <span style="font-weight:bold;">【{{ row.view_date_time }}】&nbsp;&nbsp;{{ row.message }}</span>
    <span style="padding-left:6em;font-size:small;">※画像をクリックすると拡大出来ます。</span>
  </div>
  <el-row>
    <viewer :images="images" :options="options" style="padding-left:4%;">
      <img v-for="src in images" :key="src" :src="src" crossorigin="use-credentials" style="border: 1px solid black;">
    </viewer>
  </el-row>
</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  props: ['row'],
  emits: ['dialogClose'],
  data() {
    return {
      images: [],
      options: {
        "inline": false,
        "button": true,
        "navbar": false,
        "title": false,
        "toolbar": false,
        "tooltip": false,
        "movable": true,
        "zoomable": true,
        "rotatable": false,
        "scalable": false,
        "transition": true,
        "fullscreen": true,
        "keyboard": true
      }
    };
  },
  updated() {
    this.images = [this.row.fullSizeImagePath];
  },
  mounted() {
    this.images = [this.row.fullSizeImagePath];
  },
  methods: {
  },
})
</script>

<style scoped>
img {
  width: 95%;
  height: 95%;
  /* object-fit: contain; */
}

/* .el-overlay {
  z-index: 2015!important;
} */
</style>
